import { FunctionComponent, ReactNode } from 'react';

interface OneColumnGridProps {
  children: ReactNode;
  className?: string;
}

export const OneColumnGrid: FunctionComponent<OneColumnGridProps> = ({ children, className }) => {
  return <div className={`flex flex-col bg-gray-100 rounded-lg gap-2 p-2 w-full ${className ?? ''}`}>{children}</div>;
};
